<template>
    <chat-slide-out-panel
        class="chat-slideout"
        v-model="visible"
        @close="onClose"
        :key="randomKey"
        :count="1"
        :widths="['auto']"
        :styles="[
      {},
      {},
      {},
      {
        color: '#555',
        textDecoration: 'none',
        top: '8px',
        right: '0.5rem'
      }
    ]"
        closeHtml="<div class='el-button el-button--default el-button--small is-circle'><i class='el-icon-close' aria-hidden='true'></i></div>"
    >
        <el-container class="chat" style="height: 100%; border: 1px solid #eee">
            <el-aside class="chat-availability" width="300px" style="background-color: #f9f9f9;">
                <chat-tool-box/>
                <el-collapse v-model="activeGroup" @change="handleChange">
                    <el-collapse-item v-if="_.size(groups) > 0" title="Groups" name="1"
                                      :key="`groups-${_.size(groups)}`">
                        <div
                            @click="setCurrentChat(group)"
                            class="chat-user"
                            style="padding: 0.5rem;"
                            v-for="(group, index) in groups"
                            :key="index"
                        >
                            <el-badge
                                :value="unreadMessageCount[group.channel_name]"
                                :max="99"
                                class="item"
                                :hidden="unreadMessageCount[group.channel_name] == 0"
                            >
                                <el-avatar class="mr-2" :style="`background:${getColour(group.name)}`">
                                    {{ getInitials(group.name) }}
                                </el-avatar>
                            </el-badge>
                            <span>{{ group.name }}</span>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item v-if="_.size(usersOnline) > 0" name="2" :key="`online-${_.size(usersOnline)}`">
                        <template slot="title">
                            <el-tag type="success" round size="mini" class="mr-2">{{ _.size(usersOnline) }}</el-tag>
                            Online Team Members
                        </template>
                        <div
                            @click="setCurrentChat(user)"
                            class="chat-user"
                            style="padding: 0.5rem;"
                            v-for="(user, index) in usersOnline"
                            :key="index"
                        >
                            <el-badge :value="unreadMessageCount[user.id]" :max="99" class="item"
                                      :hidden="unreadMessageCount[user.id] == 0">
                                <el-avatar class="mr-2" :src="_.get(user, 'avatar', null)"
                                           :style="`background:${getColour(user.full_name)}`">
                                    {{ getInitials(user.full_name) }}
                                </el-avatar>
                            </el-badge>
                            <div>
                                <span>{{ user.full_name }}</span><br
                                v-if="_.get(user.user_settings, 'chat.status', '')"/>
                                <small v-if="_.get(user.user_settings, 'chat.status', '')">{{
                                        _.get(user.user_settings, 'chat.status', '')
                                    }}</small>
                            </div>
                        </div>
                    </el-collapse-item>
                    <el-collapse-item
                        v-if="_.size(usersOffline) > 0"
                        title="Offline Team Members"
                        name="3"
                        :key="`offline-${_.size(usersOffline)}`"
                    >
                        <div
                            @click="setCurrentChat(offline)"
                            class="chat-user"
                            style="padding: 0.5rem;"
                            v-for="(offline, index) in usersOffline"
                            :key="index"
                        >
                            <el-badge
                                :value="unreadMessageCount[offline.id]"
                                :max="99"
                                class="item"
                                :hidden="unreadMessageCount[offline.id] == 0"
                            >
                                <el-avatar class="mr-2" :src="_.get(offline, 'avatar', null)"
                                           :style="`background:${getColour(offline.full_name)}`">
                                    {{ getInitials(offline.full_name) }}
                                </el-avatar>
                            </el-badge>
                            <span>{{ offline.full_name }}</span>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </el-aside>
            <el-container v-if="currentChat" :key="currentChat.id" class="chat-container">
                <el-header class="chat-header">
                    <div>
                        <span class="chat-title">
                            <i :class="typing ? 'el-icon-chat-dot-round' : 'el-icon-chat-round'"></i>
                            {{ _.get(currentChat, "full_name", _.get(currentChat, "name")) }}
                        </span>
                    </div>
                    <inner-chat-tool-box v-if="_.has(currentChat, 'name')" :current-chat="currentChat"/>
                </el-header>
                <el-main style="flex-direction: column;">
                    <div class="row w-100 chat-window" ref="chat_board">
                        <infinite-loading
                            :identified="`chat-app-${currentChat.id}`"
                            @infinite="infiniteHandler"
                            spinner="spiral"
                            direction="top"
                        >
                            <div slot="no-more"></div>
                            <div slot="no-results"></div>
                        </infinite-loading>
                        <div v-for="(msg, index) in messages" :key="index" class="col-12 message-block pb-3">
                            <div>
                                <chat-time :time="msg.created_at"/>
                            </div>
                            <div class="row">
                                <div
                                    :class="`col-12 justify-content-${myself.id == msg.sender_id ? 'end' : 'start'} d-flex`">
                                    <div :class="`text-${myself.id == msg.sender_id ? 'right' : 'left'}`">
                                        <small>{{
                                                myself.id == msg.sender_id ? myself.full_name : getUser(currentChat, msg.sender_id)
                                            }}</small>
                                    </div>
                                </div>
                                <div :class="`col-12`">
                                    <div
                                        :class="`d-flex w-100 align-items-end justify-content-${myself.id == msg.sender_id ? 'end' : 'start'}`">
                                        <div v-if="myself.id != msg.sender_id" :class="`order-1 pr-3`">
                                            <el-avatar :src="_.get(currentChat, 'avatar', null)"
                                                       :style="`background:${getColour(getUser(currentChat, msg.sender_id))}`">
                                                {{ getInitials(getUser(currentChat, msg.sender_id)) }}
                                            </el-avatar>
                                        </div>
                                        <div
                                            :class="
                        `order-${myself.id == msg.sender_id ? '1' : '2'} d-flex justify-content-${
                          myself.id == msg.sender_id ? 'end' : 'start'
                        }`
                      "
                                        >
                                            <Message
                                                :class="`message ${myself.id == msg.sender_id ? 'self' : 'other'}`"
                                                :message="msg.message"
                                                :message-id="index"
                                            ></Message>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-main>
                <el-footer>
                    <div class="d-flex align-items-center" style="height:30px;">
                        <small v-show="typing">{{ whosTyping }} is typing...</small>
                    </div>
                    <el-input
                        type="textarea"
                        :rows="3"
                        :autofocus="true"
                        :autosize="{ minRows: 3, maxRows: 3 }"
                        placeholder="Type something"
                        v-model="message"
                        @keyup.enter.native="sendMessage"
                        @keydown.native="isTyping"
                    ></el-input>
                </el-footer>
            </el-container>
        </el-container>
    </chat-slide-out-panel>
</template>

<script>
import {mapGetters, mapState, mapMutations} from "vuex"
import InfiniteLoading from "vue-infinite-loading"
import ChatSlideOutPanel from "./ChatSlideOutPanel.vue"
import Message from "./Message.vue"
import {ulid} from "ulid"

export default {
    name: "TenantChatContainer",
    components: {
        ChatSlideOutPanel,
        InfiniteLoading,
        Message
    },
    props: {},
    data() {
        return {
            chatChannels: {},
            visible: false,
            message: "",
            page: 0,
            activeGroup: ["1"],
            currentChat: null,
            typing: false,
            whosTyping: "",
            messages: [],
            incomingMessage: false,
            documentTitle: document.title,
            groupKey: "",
            randomKey: ulid(),
        }
    },
    created() {
        this.registerChats()
    },
    computed: {
        ...mapGetters({
            tenant: "chat/tenant",
            usersOnline: "chat/usersOnline",
            myself: "chat/myself",
            usersOffline: "chat/getOfflineMembers",
            unreadMessageCount: "chat/unreadMessageCount",
            chatVisible: "chat/chatVisible",
            groups: "chat/groups",
            members: "chat/members"
        }),
        messageStatus() {
            return this.incomingMessage ? "New chat message...." : this.documentTitle
        }
    },
    watch: {
        messageStatus(newVal, oldVal) {
            if (this.incomingMessage) {
                this.incomingMessage = false
                document.title = newVal

                setTimeout(() => {
                    document.title = this.messageStatus
                }, 5000)
            }
        }
    },
    mounted() {
        this.$bus.$on("toggle-tenant-messaging", value => {
            this.visible = value
            if (this.visible == false) {
                this.messages = []
                this.currentChat = null
            }
        })
        this.$bus.$on("chat::reset::connection", () => {
            this.randomKey = ulid();
        })
        this.$bus.$on("chat::reset::current", () => {
            this.messages = []
            this.currentChat = null
        })
        this.$bus.$on("chat::groups::update", () => {
            this.groupKey = ulid()
        })

        this.$store.dispatch("global commit", {type: "chat/setChatVisible", payload: true})

        this.groupKey = ulid()
        if (_.size(this.groups) > 0) {
            this.activeGroup.push("2")
        }

        document.addEventListener("visibilitychange", () => {
            this.$store.dispatch("global commit", {type: "chat/setChatVisible", payload: !document.hidden})
        })
    },
    updated() {
    },
    activated() {
    },
    methods: {
        registerChats() {
            this.chatChannels.self = Echo.private("tenant_app_messaging." + this.tenant + "." + this.myself.id)
                .listen(".global.message", e => {
                    if (e.appMessage.sender_id !== this.myself.id) {
                        if (this.visible) {
                            console.log('i am visible');
                            if (!_.isEmpty(this.currentChat) && this.currentChat.id != e.appMessage.sender_id) {
                                let sender = this.unreadMessageCount[e.appMessage.sender_id]
                                console.log('currentChat is Not EMpty');
                                console.log('currentChat is Not EMpty setIncomingMessage ', sender);
                                this.$store.dispatch("chat/setUnreadMessageCount", {
                                    id: e.appMessage.sender_id,
                                    count: !sender ? 1 : (sender += 1)
                                })
                            } else if (_.isEmpty(this.currentChat)) {
                                console.log('currentChat is EMpty');
                                let sender = this.unreadMessageCount[e.appMessage.sender_id]
                                this.$store.dispatch("chat/setUnreadMessageCount", {
                                    id: e.appMessage.sender_id,
                                    count: !sender ? 1 : (sender += 1)
                                })

                                console.log('currentChat is EMpty setIncomingMessage ', sender, e.appMessage.sender_id, this.unreadMessageCount);
                            } else {
                                console.log('currentChat is unsure EMpty');
                                this.messages.push(e.appMessage)

                                this.$nextTick(() => {
                                    this.$refs.chat_board.scrollTop = _.get(this.$refs, 'chat_board.scrollHeight')
                                })

                                this.$store.dispatch("chat/setUnreadMessageCount", {
                                    id: e.appMessage.sender_id,
                                    count: 0
                                })
                            }
                        } else {
                            this.incomingMessage = true
                            let sender = this.unreadMessageCount[e.appMessage.sender_id]
                            console.log('sender setIncomingMessage ', sender);

                            this.$store.dispatch("chat/setUnreadMessageCount", {
                                id: e.appMessage.sender_id,
                                count: !sender ? 1 : (sender += 1)
                            })
                        }

                        this.updateMessageCount()

                        Notification.requestPermission(permission => {
                            if (!this.chatVisible) {
                                let length = 50
                                let trimmedString =
                                    e.appMessage.message.length > length
                                        ? e.appMessage.message.substring(0, length - 3) + "..."
                                        : e.appMessage.message
                                let notification = new Notification("New Ambition Message", {
                                    body: trimmedString,
                                    icon: "https://ambitioncloud.s3-ap-southeast-2.amazonaws.com/logo.png"
                                })

                                notification.onclick = () => {
                                    // window.open(window.location.href);
                                }
                            }
                        })
                    }
                })
                .listenForWhisper("typing", e => {
                    this.whosTyping = e.user
                    this.typing = e.typing

                    // remove is typing indicator after 0.9s
                    setTimeout(() => {
                        this.typing = false
                    }, 3000)
                })
                .listenForWhisper("update.message.total", e => {
                    this.$store.dispatch("chat/setUnreadMessageCount", {id: e.id, count: 0})
                })

            if (_.size(this.groups) > 0) {
                this.groups.forEach(group => {
                    this.chatChannels[`${group.channel_name}`] = Echo.private("tenant_app_messaging." + this.tenant + "." + group.channel_name)
                        .listen(".global.message", e => {
                            if (e.appMessage.sender_id !== this.myself.id) {
                                if (this.visible) {
                                    if (!_.isEmpty(this.currentChat) && this.currentChat.channel_name != e.appMessage.channel) {
                                        let sender = this.unreadMessageCount[e.appMessage.channel]
                                        this.$store.dispatch("chat/setUnreadMessageCount", {
                                            id: e.appMessage.channel,
                                            count: !sender ? 1 : (sender += 1)
                                        })
                                    } else if (_.isEmpty(this.currentChat)) {
                                        let sender = this.unreadMessageCount[e.appMessage.channel]
                                        this.$store.dispatch("chat/setUnreadMessageCount", {
                                            id: e.appMessage.channel,
                                            count: !sender ? 1 : (sender += 1)
                                        })
                                    } else {
                                        this.messages.push(e.appMessage)

                                        this.$nextTick(() => {
                                            this.$refs.chat_board.scrollTop = _.get(this.$refs, 'chat_board.scrollHeight')
                                        })

                                        this.$store.dispatch("chat/setUnreadMessageCount", {
                                            id: e.appMessage.channel,
                                            count: 0
                                        })
                                    }
                                } else {
                                    this.incomingMessage = true
                                    let sender = this.unreadMessageCount[e.appMessage.channel]
                                    this.$store.dispatch("chat/setUnreadMessageCount", {
                                        id: e.appMessage.channel,
                                        count: !sender ? 1 : (sender += 1)
                                    })
                                }
                            }
                        })
                        .listenForWhisper("typing", e => {
                            if (e.channel == _.get(this.currentChat, "channel_name")) {
                                this.whosTyping = e.user
                                this.typing = e.typing
                                // remove i		s typing indicator after 0.9s
                                setTimeout(() => {
                                    this.typing = false
                                }, 3000)
                            }
                        })
                        .listenForWhisper("update.message.total", e => {
                            this.$store.dispatch("chat/setUnreadMessageCount", {id: e.channel, count: 0})
                        })
                })
            }
        },
        getInitials(name) {
            return name
                .split(" ")
                .map(e => e.charAt(0))
                .join("")
                .toUpperCase()
        },

        getColour(username, s = 30, l = 50) {
            var hash = 0
            for (var i = 0; i < _.size(username); i++) {
                hash = username.charCodeAt(i) + ((hash << 5) - hash)
            }

            var h = hash % 360
            return "hsl(" + h + ", " + s + "%, " + l + "%)"
        },

        getUser(currentChat, sender_id) {
            if (_.has(currentChat, "channel_name")) {
                let user = this.members.find(member => member.id == sender_id)
                return _.get(user, "full_name", "removed user")
            }
            return currentChat.full_name
        },

        setCurrentChat(user) {
            if (_.isEmpty(this.currentChat) || (user.id != this.currentChat.id && !user.channel_name)) {
                let channel = Echo.private("tenant_app_messaging." + this.tenant + "." + this.myself.id)
                this.page = 1
                this.messages = []
                this.currentChat = user
                this.$store.dispatch("chat/setUnreadMessageCount", {id: user.id, count: 0})
                channel.whisper("update.message.total", {id: user.id, count: 0})
                this.updateMessageCount()
                this.$bus.$emit("toggle-private-message", true)
            } else if (user.channel_name) {
                let channel = Echo.private("tenant_app_messaging." + this.tenant + "." + user.channel_name)
                this.page = 1
                this.messages = []
                this.currentChat = user
                this.$store.dispatch("chat/setUnreadMessageCount", {id: user.channel_name, count: 0})
                channel.whisper("update.message.total", {channel: user.channel_name, count: 0})
                this.updateMessageCount()
                this.$bus.$emit("toggle-private-message", true)
            }
        },

        newline() {
            this.message = `${this.message}`
        },

        async sendMessage(e) {
            e.preventDefault()
            if (!e.shiftKey && this.message.trim()) {
                try {
                    this.messages.push({
                        message: this.message.trim(),
                        created_at: this.$moment(new Date())
                            .utc()
                            .format("YYYY-MM-DD HH:mm:ss"),
                        user: this.myself,
                        sender_id: this.myself.id,
                        participant: this.currentChat
                    })

                    this.$nextTick(() => {
                        this.$refs.chat_board.scrollTop = _.get(this.$refs, 'chat_board.scrollHeight')
                    })
                    let res = await axios.post(
                        `/api/v2/global-messaging`,
                        {
                            message: this.message,
                            participant: _.get(this.currentChat, "channel_name", this.currentChat.id),
                            user: this.myself.id,
                            group: _.has(this.currentChat, "channel_name"),
                            channel_name: _.get(this.currentChat, "channel_name", "")
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${this.$store.getters.token}`
                            }
                        }
                    )
                    this.message = ""
                } catch (err) {
                    console.error(err)
                    this.$message({
                        message: "Error Sending Message",
                        type: "error"
                    })
                }
            } else if (e.shiftKey) {
                this.newline()
            }
        },

        async updateMessageCount() {
            try {
                let res = await axios.post(
                    `/api/v2/global-messaging-count/${this.myself.id}`,
                    {
                        count: this.unreadMessageCount
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${this.$store.getters.token}`
                        }
                    }
                )
            } catch (err) {
                console.error(err)
            }
        },

        infiniteHandler: _.throttle(async function ($state) {
            try {
                let messages = await this.getMessages()
                if (_.size(messages)) {
                    if (_.size(this.messages)) {
                        this.messages.unshift(...messages)
                    } else {
                        this.messages = messages
                        this.$nextTick(() => {
                            this.$refs.chat_board.scrollTop = _.get(this.$refs, 'chat_board.scrollHeight')
                        })
                    }

                    this.page++
                    $state.loaded()
                } else {
                    $state.complete()
                }
            } catch (Err) {
                console.error(Err)
                $state.error()
            }
        }, 500),

        async getMessages() {
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await axios.get(`/api/v2/global-messaging`, {
                        headers: {
                            Authorization: `Bearer ${this.$store.getters.token}`
                        },
                        params: {
                            page: this.page,
                            participant: _.has(this.currentChat, "channel_name") ? this.currentChat.channel_name : this.currentChat.id,
                            user: this.myself.id,
                            group: _.has(this.currentChat, "channel_name")
                        }
                    })
                    resolve(res.data.data.reverse())
                } catch (err) {
                    console.error(err)
                    reject(err)
                }
            })
        },

        handleChange(val) {
        },

        isTyping(e) {
            let channel = Echo.private(
                "tenant_app_messaging." + this.tenant + "." + _.get(this.currentChat, "channel_name", this.currentChat.id)
            )

            setTimeout(() => {
                channel.whisper("typing", {
                    channel: _.get(this.currentChat, "channel_name", null),
                    user: this.myself.first_name,
                    typing: true
                })
            }, 2000)
        },

        onClose(param) {
            this.messages = []
            this.$bus.$emit("toggle-tenant-messaging", false)
            this.currentChat = null
        }
    }
}
</script>

<style lang="scss">
.inner-chat-menu-dropdown {
    z-index: 2000000 !important;
}

.chat-slideout {
    .el-collapse-item__wrap {
        padding: 0.5rem;

        .chat-user {
            display: flex;
            align-items: center;

            &:hover {
                cursor: pointer;
                background: #2689df;
                color: #fff;
                border-radius: 1rem;
                transition: 200ms background ease-in-out;
            }
        }
    }

    .blackout {
        display: none !important;
    }

    .dock {
        max-width: 100% !important;
    }

    .action-close {
        height: 32px;
    }

    .chat-availability {
        &::-webkit-scrollbar {
            display: none;
        }

        -ms-overflow-style: none;
        /* IE and Edge */
        scrollbar-width: none;
        /* Firefox */
        .el-collapse-item__header {
            padding-left: 0.5rem !important;
        }

        .el-collapse {
            .el-collapse-item__wrap {
                background: #f9f9f9;
            }
        }
    }

    .chat-container {
        width: 600px;
        max-width: 100% !important;
        -ms-overflow-style: none;
        /* IE and Edge */
        scrollbar-width: none;
        /* Firefox */
        &::-webkit-scrollbar {
            display: none;
        }
    }

    .chat-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: right;
        font-size: 12px;
        padding-right: 40px;
        background: #2689e0;
        color: #fff;

        .chat-title {
            display: flex;
            align-items: center;

            i {
                font-size: 1.5rem;
                margin-right: 1rem;
            }
        }

        .el-icon-setting {
            color: #fff;
        }
    }

    .chat-window {
        &::-webkit-scrollbar {
            display: none;
        }

        -ms-overflow-style: none;
        /* IE and Edge */
        scrollbar-width: none;
        /* Firefox */
        .message-block {
            .chattime {
                &.oneWeekOrMore {
                    opacity: 0;
                }
            }

            &:hover {
                .chattime {
                    opacity: 1;

                    &.oneWeekOrMore {
                        opacity: 1;
                    }
                }
            }
        }
    }

    .el-footer {
        height: 100px !important;
        padding: 10px !important;

        textarea {
            resize: none !important;
            box-shadow: none !important;
        }
    }

    .infinite-loading-container {
        min-width: 100%; // display: flex;
        // align-items: center;
        // justify-content: center;
        text-align: center;
    }
}
</style>
